<template>
  <vue-scroll class="type-document">
    <div class="page-header">
      <h1><i :class="'mdi mdi-'+ $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
          <h2>Datos de registro</h2>
          <el-form
            :model="form"
            ref="form"
            status-icon
            label-width="180px"
            size="medium"
            class="demo-form"
            :rules="rules"
            :label-position="(innerWidth > 1300) ? 'left' : 'top'"
            v-loading="loadingForm"
          >
            <el-form-item label="Descripción" prop="description">
              <el-input
                v-model="form.description"
                autocomplete="off"
                placeholder="Descripción"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Prefijo" prop="prefix">
              <el-input v-model="form.prefix" autocomplete="off" placeholder="Prefijo" clearable></el-input>
            </el-form-item>
            <el-form-item label="Resolución DIAN" prop="resolution_dian">
              <el-input
                v-model="form.resolution_dian"
                autocomplete="off"
                placeholder="# Resolución"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Fecha autorización DIAN" prop="autorization_dian">
              <el-date-picker
                v-model="form.autorization_dian"
                type="date"
                placeholder="yyyy-mm-dd"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Vigencia autorización DIAN" prop="validity_dian">
              <el-input
                v-model="form.validity_dian"
                autocomplete="off"
                placeholder="00 Meses"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Rango autorización DIAN" prop="range_dian">
              <el-input
                v-model="form.range_dian"
                autocomplete="off"
                placeholder="01 al 0000001"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <!-- <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-check"
                v-if="!edit"
              >Guardar</el-button>-->
              <el-button
                type="warning"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-edit"
              >Actualizar</el-button>
              <el-button @click="resetForm('form')" icon="el-icon-close">Cancelar</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- grid -->
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
          <el-table
            :data="tableData.filter(data => !search || data.descripcion.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%; margin-top:20px;"
            height="500"
            v-loading="loadingTable"
          >
            <el-table-column label="Id" prop="id" width="50"></el-table-column>
            <el-table-column label="Descripcion" prop="descripcion"></el-table-column>
            <el-table-column label="Prefijo" prop="prefijo" width="70"></el-table-column>
            <el-table-column label="Consecutivo" prop="consecutivo" width="100"></el-table-column>
            <el-table-column label="Transacción" prop="id_transaccion" width="100">
              <template slot-scope="scope">
                <el-tag type="success" size="mini" v-if="scope.row.id_transaccion == 1">Entrada</el-tag>
                <el-tag type="danger" size="mini" v-if="scope.row.id_transaccion == 2">Salida</el-tag>
                <el-tag type="info" size="mini" v-if="scope.row.id_transaccion == 0">Ninguna</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Digite la descripción" />
              </template>
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                  <el-button
                    size="mini"
                    type="warning"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-edit"
                    circle
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
import { store, update, getAll, getById, deleteData } from "@/api/typeDocument";
export default {
  name: "Store",
  components: {},
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingTable: false,
      edit: false,
      innerWidth: 0,
      labelPosition: "top",
      form: {
        id: "",
        description: "",
        prefix: "",
        resolution_dian: "",
        autorization_dian: "",
        validity_dian: "",
        range_dian: "",
      },
      rules: {
        description: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        prefix: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      search: "",
    };
  },
  methods: {
    resizeOpenNav() {
      this.innerWidth = window.innerWidth;
    },
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.edit) {
            this.updateForm();
          } else {
            this.saveForm();
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveForm() {
      var datas = this.setDatas();
      store(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    updateForm() {
      var datas = this.setDatas();
      update(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    setDatas() {
      return {
        id: this.form.id,
        descripcion: this.form.description,
        prefijo: this.form.prefix,
        metadata: {
          resolution_dian: this.form.resolution_dian,
          autorization_dian: this.form.autorization_dian,
          validity_dian: this.form.validity_dian,
          range_dian: this.form.range_dian,
        },
      };
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.loading = false;
      this.edit = false;
    },
    getTableData() {
      this.loadingTable = true;
      getAll()
        .then(({ data }) => {
          this.loadingTable = false;
          this.tableData = data;
        })
        .catch(function (error) {
          this.loadingTable = false;
          console.log(error);
        });
    },

    // table
    handleEdit(index, row) {
      let me = this;
      this.loadingForm = true;
      getById(row.id)
        .then(({ data }) => {
          var metadata = JSON.parse(data.meta_data);
          this.edit = true;
          this.loadingForm = false;
          this.form = {
            id: data.id,
            description: data.descripcion,
            prefix: data.prefijo,
            resolution_dian: (metadata !== null) ? metadata.data_dian.resolution_dian : '',
            autorization_dian: (metadata !== null) ?  metadata.data_dian.autorization_dian : '',
            validity_dian: (metadata !== null) ?  metadata.data_dian.validity_dian : '',
            range_dian: (metadata !== null) ?  metadata.data_dian.range_dian : '',
          };
        })
        .catch(function (error) {
          console.log("Err: ", error);
        });
    },
    handleDelete(index, row) {
      this.$confirm("Desea eliminar este registro?", "Atención!", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          deleteData(row.id)
            .then(({ data }) => {
              this.loading = false;
              if (data.code === 200) {
                this.getTableData();
                this.resetForm("form");
              } else {
                this.$message.error("Error! " + data.error.errorInfo[2]);
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log("Err: ", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operación Cancelada",
          });
        });
    },
  },
  created() {
    this.getTableData(); 
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);
  },
};
</script>

<style lang="scss">
@import '../../../../assets/scss/_variables';
.el-select {
  width: 100%;
}
.el-icon-circle-check {
  color: #1cc529;
}
</style>
